import { useState } from "react";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmt, fmtAxis } from "@/lib/format";

const ALL = "__all__";

const UnitPick = ({ units, value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid="breakdown-unit-select" className="h-8 w-48 text-xs"><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL}>Semua UP3</SelectItem>
      {units.map((u) => <SelectItem key={u} value={u}>{u}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const BreakdownChart = ({ breakdown, unit = ALL, onUnit }) => {
  const [own, setOwn] = useState(ALL);
  const sel = onUnit ? unit || ALL : own;
  const setUnit = (v) => (onUnit ? onUnit(v === ALL ? null : v) : setOwn(v));
  if (!breakdown) return null;
  const units = breakdown.units ? Object.keys(breakdown.units) : [];
  const src = sel !== ALL && breakdown.units?.[sel] ? breakdown.units[sel] : breakdown;
  const data = src.data.slice(0, 15);
  return (
    <div data-testid="breakdown-chart" className="rounded-xl border bg-card p-4 sm:p-5 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <h3 className="font-heading text-base sm:text-lg font-semibold">{breakdown.title}</h3>
        {units.length > 1 && <UnitPick units={units} value={sel} onChange={setUnit} />}
      </div>
      {breakdown.note && <p className="text-xs text-muted-foreground">{breakdown.note}</p>}
      {src.groups?.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {src.groups.map((g) => (
            <span key={g.name ?? "-"} data-testid={`breakdown-group-${String(g.name ?? "lainnya").toLowerCase().replace(/\s+/g, "-")}`} className="rounded-md border bg-muted px-2 py-1 text-xs">
              {g.name}: <b className="font-num">{fmt(g.value, breakdown.fmt)}</b>
            </span>
          ))}
        </div>
      )}
      {data.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground">Tidak ada data pada periode ini.</p>
      ) : (
        <div className="mt-4" style={{ height: Math.max(180, data.length * 30) }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ left: 0, right: 16 }}>
              <XAxis type="number" tick={{ fontSize: 10 }} tickFormatter={(v) => fmtAxis(v, breakdown.fmt)} axisLine={false} tickLine={false} />
              <YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 10 }} axisLine={false} tickLine={false} />
              <Tooltip formatter={(v) => fmt(v, breakdown.fmt)} contentStyle={{ borderRadius: 10, fontSize: 12 }} />
              <Bar dataKey="value" name="Nilai" radius={[0, 4, 4, 0]} maxBarSize={18}>
                {data.map((d, i) => <Cell key={d.name} fill={i === 0 ? "#F5A623" : "var(--chart-navy)"} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
